module.exports = function () {
    const cartToolsWrap  = require('./woocommerce/cart-tools-wrap')
    
    cartToolsWrap()
}